import { render, staticRenderFns } from "./GoodsCategoryEdit.vue?vue&type=template&id=f48766c2&"
import script from "./GoodsCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports